import {Component, OnInit} from '@angular/core';
import {AppRoutingModule} from '../../app-routing.module';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MessageService} from '../../services/message.service';
import {EntitlementService} from '../../services/entitlement.service';
import {CardholderService} from '../../services/cardholder.service';
import {FormUtils} from '../../FormUtils';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';
import {CardholderDetails} from "../../data/CardholderDetails";
import {Card} from "../../data/Card";
import {Identity} from '../../Identity';
import {FormMeta} from '../../data/FormMeta';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-forms-history',
  templateUrl: './forms-history.component.html',
  styleUrl: './forms-history.component.css'
})
export class CardholderFormsHistoryComponent implements OnInit{

  cardholder: ProfileSearchResult;
  cardsAccount: Card[];
  identity: Identity;
  enrollForms: FormMeta[] = [];
  retrievingForms = false;
  pagedMerchantForms: FormMeta[] = [];
  itemsPerPage = 5;
  page = 1;
  subscriptions: Subscription[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private formUtils: FormUtils
  ) { }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.retrievingForms = true;
    this.cardHolderService.getMerchantForms(this.cardholder.payrollAccount.toString()).subscribe(
      (forms: FormMeta[]) : void => {
        this.enrollForms = forms;
        this.retrievingForms = true;
        this.enrollForms.sort((a: any, b: any) => {
          const useDateA = new Date(a.formDate).getTime();
          const useDateB = new Date(b.formDate).getTime();
          return useDateB - useDateA;
        });
        this.pageSet(1, true);
      },
      (error) => {
        this.messageService.error(error.message);
        this.retrievingForms = false;
      },
      () => {

      }

    );

  }



  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;

  }


  getEnrollmentForm(form: FormMeta) {
    this.cardHolderService
    .downloadEnrollmentPDF(form.idSeq, form.formSeq, form.fileName)
    .subscribe(
      (data) => {
        const pdfFile = new Blob([data], { type: 'application/pdf' });
        const pdfURL = URL.createObjectURL(pdfFile);
        window.open(pdfURL);
      },
      (error) => this.messageService.error(error.message)
    );
  }

  pageSet(page, scrollTop = true) {
    this.page = page;
    this.paginate();
    if (scrollTop) {
      window.scrollTo(0, 300);
    }
  }

  paginate() {
    if (this.enrollForms.length <= this.itemsPerPage) {
      this.pagedMerchantForms = this.enrollForms;
    } else {
      this.pagedMerchantForms = this.enrollForms.slice(
        (this.page - 1) * this.itemsPerPage,
        (this.page - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }

  setItemsPerPage(evt) {
    const itemsPerPage = evt.target.value;
    this.itemsPerPage = itemsPerPage;
    this.pageSet(this.page, true);
  }


}


